export const imageTemplate = {
  '_template': 'image',
  'media': {
    'src': '/placeholder.jpg',
    alt: 'image'
  }
};
export const imagesTemplate = {
  _template: 'images',
  blocks: [
    imageTemplate,
    imageTemplate,

  ],
  text: {
    align: {
      xl: 'center'
    }
  }
};
